const awsConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_dNd7EOFby',
  aws_user_pools_web_client_id: '33c4glh0765flnu8m0diuqs9je',
  aws_appsync_graphqlEndpoint: 'https://le3mt7znejbrfocvtg2646uwwm.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: 'da2-bucz5zsxffg65hn5wyoc5bzpba',
};

export default awsConfig;
